import { Button } from '@/ui/Button'
import { Tooltip } from '@/ui/Tooltip'
import { ControlSheetTrip } from '../../types/types'
import clsx from 'clsx'
import styles from '../ControlSheetCells.module.scss'
import { runTripTooltip, runTripTooltipMealRelief } from './RunTripTooltip'

import ChevronRight from '../../assets/chevron-right.svg'
import { AnnotationsPermission } from '@/pages/ControlSheet/ui/ControlSheetPage'

type Props = {
    trip?: ControlSheetTrip
    tripRoute?: string
    isNextTrip?: boolean
    withLink?: boolean
    annotationsPermission: AnnotationsPermission
    navigateToTrip?: (trip: string) => void
}

export const TripCell = (props: Props) => {
    const { trip, tripRoute, isNextTrip, withLink, annotationsPermission, navigateToTrip } = props

    if (trip?.isTakeoverRow) {
        if (isNextTrip) {
            return <div className={clsx(styles.tripNumber)}>{trip.trip}</div>
        } else {
            return <></>
        }
    }

    let tripToShow
    if (trip && isNextTrip) {
        tripToShow = trip?.nextTripForDuty
    } else {
        tripToShow = trip?.trip
    }

    const routeAfterBreak = trip?.routeAfterBreak

    const shouldShowLink = withLink && routeAfterBreak === tripRoute

    const tripCell = (
        <div className={clsx(styles.cell, styles.tripAndButtonContainer)}>
            <div
                className={clsx(styles.tripAndRouteContainer, {
                    [styles.rightAlign]: shouldShowLink,
                })}
            >
                <span className={styles.trip}>
                    <span className={styles.tripNumber}>{tripToShow}</span>
                    {trip?.departGarage && !isNextTrip && <span className={styles.tripGarage}>{trip?.depotCode}</span>}
                </span>
                {withLink && !shouldShowLink && routeAfterBreak && (
                    <span className={styles.nextRoute}>Route {routeAfterBreak}</span>
                )}
            </div>

            {shouldShowLink && (
                <Button
                    variant="tertiary"
                    size="xs"
                    className={styles.rounded}
                    onClick={() => {
                        navigateToTrip?.(tripToShow || '')
                    }}
                >
                    <ChevronRight />
                </Button>
            )}
        </div>
    )

    if ((trip?.departGarage && !isNextTrip) || trip?.lateMealReliefMayAffect) {
        let tooltip

        if (trip?.departGarage && !isNextTrip) {
            tooltip = runTripTooltip(trip, trip?.lateMealReliefMayAffect)
        } else {
            // Late meal relief may affect this trip
            tooltip = runTripTooltipMealRelief(trip, annotationsPermission)
        }
        return (
            <Tooltip tooltip={tooltip} placement="bottom" trigger="hover">
                {tripCell}
            </Tooltip>
        )
    }

    return tripCell
}
